import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import BaseModal from './Modal'
import { isOpen, closeTimeoutMS, contentLabel, children, restProps } from 'store/entities/modal/selectors'
import { modal } from 'store/entities/modal/actions'

console.log('__BaseModal__')
const mapStateToProps = createStructuredSelector({
  isOpen,
  closeTimeoutMS,
  contentLabel,
  children,
  restProps,
})

const mapDispatchToProps = {
  onRequestClose: modal.hide,
}

export default connect(mapStateToProps, mapDispatchToProps)(BaseModal)
